import { useEffect } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Chip, CircularProgress } from '@mui/material';
import DoneIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import { useTranslation } from '../../i18n';
import { format } from '../../i18n/I18nProvider';
import { agentJobs, isActive, newestJob, useAgentJobs } from '../../lib/agentJobs';

// Header pill for video-agent jobs: "2 rendering" while any run, "Your video
// is ready" when one finishes while the user is on another page. Links back
// to the chat. Also where a fresh page load picks up running jobs.
export function AgentJobsIndicator() {
  const t = useTranslation().videoAgent;
  const jobs = useAgentJobs();
  const location = useLocation();
  const openConv = location.pathname === '/agent' ? new URLSearchParams(location.search).get('c') : null;

  useEffect(() => {
    void agentJobs.bootstrap();
  }, []);

  const unseen = jobs.filter((j) => j.unseen && j.conversationId && j.conversationId !== openConv);
  const active = jobs.filter((j) => isActive(j) && j.conversationId && j.conversationId !== openConv);

  if (unseen.length) {
    const j = newestJob(unseen)!;
    const failed = j.status === 'failed';
    return (
      <Chip
        component={RouterLink}
        to={`/agent?c=${j.conversationId}`}
        clickable
        size="small"
        color={failed ? 'error' : 'success'}
        variant="outlined"
        icon={failed ? <ErrorIcon /> : <DoneIcon />}
        label={failed ? t.jobFailedNotice : j.kind === 'video' ? t.jobReadyVideo : t.jobReadyImage}
        onClick={() => agentJobs.markSeen(j.activityId)}
        sx={{ fontWeight: 600 }}
      />
    );
  }

  if (!active.length) return null;
  const newest = newestJob(active)!;
  return (
    <Chip
      component={RouterLink}
      to={`/agent?c=${newest.conversationId}`}
      clickable
      size="small"
      variant="outlined"
      icon={<CircularProgress size={12} sx={{ ml: '6px !important' }} />}
      label={format(t.jobsRunning, { n: active.length })}
      title={newest.title || undefined}
      sx={{ fontWeight: 600 }}
    />
  );
}
